import { PropsWithChildren, ReactNode } from 'react'
import { Box } from '@machobear/design-system'

interface Props extends PropsWithChildren {
  icon: ReactNode
  testId: string
}

export const InsightBlock = ({ icon, testId, children }: Props) => (
  <Box
    display="flex"
    flexDirection="row"
    alignItems="flexStart"
    borderBottom="borderNeutralLight"
    gap="small"
    paddingX="xsmall"
    paddingY="medium"
    data={{ testid: testId }}
  >
    <Box>{icon}</Box>
    <Box display="flex" flexDirection="column" justifyContent="center" gap="small">
      {children}
    </Box>
  </Box>
)
